// removed by extract-text-webpack-plugin
module.exports = {"CloseButton":"_bbfO1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Mobile/MobileCloseBookingEngineButton/MobileCloseBookingEngineButton.scss
// module id = 885
// module chunks = 0